import React from 'react';
import { ReportHeroModel } from './ReportHero';
import HeroData from './HeroData';
import { Breadcrumbs, FullPageEmbeddedMediaElement, ResponsiveImage, Stack, Text } from '@/components';
import classNames from 'classnames';

export type FullWidthBannerType = ReportHeroModel;

const FullWidthBanner = (data: FullWidthBannerType) => {
  const {
    heroImage,
    heroEmbedVideo,
    useHeroImageHeightForEmbedVideo,
    breadcrumbs,
    heroTextImage,
    heroTextColour,
    anchorTextColour,
    title,
  } = data.props;

  return (
    <div className="flex w-full flex-col">
      {heroEmbedVideo ? (
        <FullPageEmbeddedMediaElement
          videoEmbedCode={heroEmbedVideo}
          coverImage={heroImage}
          useHeroImageHeightForEmbedVideo={useHeroImageHeightForEmbedVideo}
        />
      ) : (
        heroImage && (
          <div className="relative">
            {heroImage.desktopImage && (
              <ResponsiveImage
                image={heroImage.desktopImage}
                widths={{ xs: 1, sm: 1024, md: 1440, lg: 1904, xl: 2560 }}
                heights={{ xs: 1, sm: 320, md: 450, lg: 595, xl: 800 }}
                className="hidden w-full sm:block"
                dataNotLazy
                preload
              />
            )}
            {heroImage?.mobileImage && (
              <ResponsiveImage
                image={heroImage.mobileImage}
                widths={{ xs: 425 }}
                dataNotLazy
                preload
                className="sm:hidden"
              />
            )}

            <div className="absolute top-0 left-0 h-full w-full">
              <div className="container flex h-full sm:items-center">
                <div className="w-5/6 py-4 sm:w-1/2 sm:py-6 lg:py-0">
                  {heroTextImage && (
                    <ResponsiveImage
                      image={heroTextImage}
                      heights={{ xs: 125, sm: 125, md: 125, lg: 125, xl: 200 }}
                      className="hidden sm:block"
                      imgProps={{
                        className: '!w-auto',
                      }}
                    />
                  )}
                  <Text
                    tag="h1"
                    className={classNames(
                      'text-[35px] leading-[52px] font-light sm:text-[50px] sm:leading-[54px] md:text-[50px] md:leading-[54px] lg:text-[70px] lg:leading-[74px] xl:text-[80px] xl:leading-[84px]',
                      heroTextImage && 'sm:hidden',
                      heroTextColour === 'Light' ? 'lg:text-white' : 'lg:text-black',
                      anchorTextColour === 'White' ? 'text-white' : 'text-black',
                    )}
                  >
                    {title}
                  </Text>
                </div>
              </div>
            </div>
          </div>
        )
      )}
      <div className="container">
        <Breadcrumbs className="py-3" data={breadcrumbs} />
      </div>

      <Stack className="container flex flex-col pt-8 pb-8 lg:pt-15 lg:pb-16">
        <HeroData {...data} />
      </Stack>
    </div>
  );
};

export default FullWidthBanner;
